import React from "react";
import * as d3 from "d3";
import PropTypes from "prop-types";

const ExpectedThreat = ({
  data,
  gridColumns,
  gridRows,
  height,
  isLandscape,
  width
}) => {
  return (
    <g mask={`url(#maskIsLandscape)`}>
      {data.map((row, i) =>
        row.map((cell, j) => (
          <g key={`${i}-${j}`}>
            <rect
              x={j * (width / gridColumns)}
              y={i * (height / gridRows)}
              width={width / gridColumns}
              height={height / gridRows}
              fill={d3
                .scaleLinear()
                .domain([
                  d3.min(data, (d) => d3.min(d)),
                  d3.max(data, (d) => d3.max(d))
                ])
                .range(["rgba(0, 0, 255, 0.05)", "#FFFF00"])(cell)}
            />
            <g
              transform={`${
                isLandscape
                  ? `rotate(0)`
                  : `rotate(-90, ${
                      j * (width / gridColumns) + width / gridColumns / 2
                    }, ${i * (height / gridRows) + height / gridRows / 2})`
              }`}
            >
              <text
                x={j * (width / gridColumns)}
                y={i * (height / gridRows)}
                dx={width / gridColumns / 2}
                dy={height / gridRows / 2}
                textAnchor="middle"
                alignmentBaseline="central"
                fontFamily="Helvetica, Arial, sans-serif"
                fontSize={10}
                fill="#000"
              >
                {cell}%
              </text>
            </g>
          </g>
        ))
      )}
    </g>
  );
};

ExpectedThreat.defaultProps = {
  data: [],
  gridColumns: 16,
  gridRows: 12,
  height: 0,
  isLandscape: true,
  range: [],
  width: 0
};

ExpectedThreat.propTypes = {
  data: PropTypes.array,
  gridColumns: PropTypes.number,
  gridRows: PropTypes.number,
  height: PropTypes.number,
  isLandscape: PropTypes.bool,
  range: PropTypes.array,
  width: PropTypes.number
};

export default ExpectedThreat;
